export let ChipsInputFocusDirective = function($interval:ng.IIntervalService): ng.IDirective {
    return {
		restrict: 'A',
		require: 'mdChips',
        link: ($scope, element, attrs, mdChipsController) => {  
            if(!mdChipsController){
                throw new Error('Chips input focus must be used on an mdChip component');
            }

			let chipsWrap;
			let i = $interval(()=>{
				chipsWrap = element.find('md-chips-wrap');
				if(!chipsWrap){ return;}
				$interval.cancel(i);
				chipsWrap.on('click',triggerFocus);
			}, 50);

			function triggerFocus(e){
				if(angular.element(e.target).attr('id') === chipsWrap.attr('id')){
					chipsWrap.find('input').focus();
				}
			}

            $scope.$on('$destroy',function(){
                chipsWrap.off('click',triggerFocus);
            });
        }
    };
}
ChipsInputFocusDirective.$inject = [
    '$interval'
];


// WEBPACK FOOTER //
// ./src/sharebase/components/chipsInputFocus/chipsInputFocus.ts